module.exports = __webpack_public_path__ + "img/paytable_icon.c69aa2b2.svg";